/**
 * Scalapay Cleanup - SEO optimized
 * Removes Scalapay widgets from pages that are not product or cart
 */
(function() {
  'use strict';

  function removeScalapayWidgets() {
    document.querySelectorAll('scalapay-widget, [data-scalapay]').forEach(function(el) {
      el.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeScalapayWidgets);
  } else {
    removeScalapayWidgets();
  }
})();
